import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Badge, Dropdown, Modal, Button, Form, Spinner } from "react-bootstrap";
import { ShoppingBag, Edit2, More, Trash, CalendarEdit } from "iconsax-react";
import { format } from 'date-fns';
import MyApiClient from "../../../api-client/MyApiClient";
import { segnalaMancanti } from "../Util/campiMancanti";

const AssociazioniPlayer = ({ userId, readOnly }) => {

    const [associazioni, setAssociazioni] = useState([]);
    const [loading, setLoading] = useState(false);

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [editDateStart, setEditDateStart] = useState('');
    const [editDateEnd, setEditDateEnd] = useState('');

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

    useEffect(() => {
        if (!userId) return;

        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoading(true);
                    const data = await apiClient.getUserMemberships(token, userId);
                    setLoading(false);

                    if (Array.isArray(data)) {
                        setAssociazioni(data);
                    }
                }
            } catch (error) {
                console.error("Error fetching memberships:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, [userId]);

    const getStatus = (item) => {
        if (item.status) {
            const isActive = item.status === 'ACTIVE' || item.status === 'CONFIRMED';
            return { label: isActive ? 'Attivo' : 'Scaduto', bg: isActive ? 'success' : 'danger' };
        }
        if (item.dateEnd) {
            const isActive = new Date(item.dateEnd) >= new Date();
            return { label: isActive ? 'Attivo' : 'Scaduto', bg: isActive ? 'success' : 'danger' };
        }
        return { label: 'N/D', bg: 'secondary' };
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setEditDateStart(item.dateStart ? item.dateStart.substring(0, 10) : '');
        setEditDateEnd(item.dateEnd ? item.dateEnd.substring(0, 10) : '');
        setShowEditModal(true);
    };

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setShowDeleteModal(true);
    };

    const handleSaveEdit = async () => {
        const mancanti = [];
        if (!editDateStart) mancanti.push({ campo: 'assoc-inizio', messaggio: 'Manca la data di inizio' });
        if (!editDateEnd) mancanti.push({ campo: 'assoc-fine', messaggio: 'Manca la data di fine' });
        else if (editDateStart && editDateEnd < editDateStart) mancanti.push({ campo: 'assoc-fine', messaggio: 'La data di fine deve essere dopo l\'inizio' });
        if (segnalaMancanti(mancanti) > 0) return;

        setShowEditModal(false);

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const clubId = tokenDetails.localId;
                const apiClient = new MyApiClient();

                setLoading(true);
                const result = await apiClient.updateClubMember(token, clubId, selectedItem.membershipId, {
                    dateStart: editDateStart,
                    dateEnd: editDateEnd
                });
                setLoading(false);

                if (result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante il salvataggio: " + result.error);
                    setModalShowed(true);
                } else {
                    setAssociazioni(prev => prev.map(a =>
                        a.membershipId === selectedItem.membershipId
                            ? { ...a, dateStart: editDateStart, dateEnd: editDateEnd }
                            : a
                    ));
                }
            }
        } catch (error) {
            console.error("Error saving:", error);
            setLoading(false);
        }
    };

    const handleConfirmDelete = async () => {
        setShowDeleteModal(false);

        try {
            const tokenDetailsString = sessionStorage.getItem('userDetails');
            if (tokenDetailsString) {
                const tokenDetails = JSON.parse(tokenDetailsString);
                const token = tokenDetails.idToken;
                const clubId = tokenDetails.localId;
                const apiClient = new MyApiClient();

                setLoading(true);
                const result = await apiClient.deleteClubMember(token, clubId, selectedItem.membershipId);
                setLoading(false);

                if (result && result.error) {
                    setModalTitle("Errore durante l'operazione");
                    setModalText("Si è verificato un errore durante l'eliminazione: " + result.error);
                    setModalShowed(true);
                } else {
                    setAssociazioni(prev => prev.filter(a => a.membershipId !== selectedItem.membershipId));
                }
            }
        } catch (error) {
            console.error("Error deleting:", error);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal className="fade" show={loading} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close"></Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col>{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            <Card>
                <Card.Header>
                    <Card.Title>Associazioni</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Struttura</th>
                                <th>Data Inizio</th>
                                <th>Data Fine</th>
                                <th>Origine</th>
                                <th>Stato</th>
                                {!readOnly && <th></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {associazioni.length === 0 && !loading && (
                                <tr><td colSpan={readOnly ? "5" : "6"} className="text-center text-muted">Nessuna associazione trovata</td></tr>
                            )}
                            {associazioni.map((item, index) => {
                                const isManual = item.source === 'MANUAL';
                                const status = getStatus(item);
                                return (
                                    <tr key={item.membershipId || index}>
                                        <td>{item.name || '-'}</td>
                                        <td>{item.dateStart ? format(new Date(item.dateStart), 'dd/MM/yyyy') : '-'}</td>
                                        <td>{item.dateEnd ? format(new Date(item.dateEnd), 'dd/MM/yyyy') : '-'}</td>
                                        <td>
                                            {isManual ? (
                                                <div className="d-flex align-items-center">
                                                    <Edit2 size="16" className="text-warning me-2" variant="Bulk" />
                                                    <div>
                                                        <span className="d-block text-black font-w500">Manuale</span>
                                                        <span className="d-block fs-12 text-muted">Inserita da struttura</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="d-flex align-items-center">
                                                    <ShoppingBag size="16" className="text-primary me-2" variant="Bulk" />
                                                    <div>
                                                        <span className="d-block text-black font-w500">Acquisto</span>
                                                        <span className="d-block fs-12 text-muted">Da un acquisto in struttura</span>
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            <Badge bg={status.bg}>{status.label}</Badge>
                                        </td>
                                        {!readOnly && (
                                        <td>
                                            <Dropdown>
                                                <Dropdown.Toggle as="div" className="btn-link i-false" style={{ cursor: 'pointer' }}>
                                                    <More size="24" className="text-primary" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item onClick={() => handleEditClick(item)}>
                                                        <CalendarEdit size="18" className="me-2 text-warning" /> Modifica date
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDeleteClick(item)} className="text-danger">
                                                        <Trash size="18" className="me-2" /> Elimina
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Modifica date associazione</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="assoc-inizio">Data Inizio *</Form.Label>
                            <Form.Control
                                id="assoc-inizio"
                                type="date"
                                value={editDateStart}
                                onChange={(e) => setEditDateStart(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="assoc-fine">Data Fine *</Form.Label>
                            <Form.Control
                                id="assoc-fine"
                                type="date"
                                value={editDateEnd}
                                onChange={(e) => setEditDateEnd(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="btn btn-light btn-add" onClick={() => setShowEditModal(false)}>Annulla</Button>
                    <Button className="btn btn-primary btn-add" onClick={handleSaveEdit}>Salva modifiche</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminare l'associazione?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    L'associazione manuale viene eliminata.
                    <br />
                    L'operazione è irreversibile.
                </Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setShowDeleteModal(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={handleConfirmDelete}>Elimina</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AssociazioniPlayer;
